// import router from "../router";

const state = {
  search: {
    q: "",
    status: ['not_started', 'in_progress'],
    owner: [],
    subcontractor: [],
    year: [],
    assign: false,
  }
  // ,
  // constructions: [],
};
const getters = {
  search: state => {
    return state.search;
  },
  // items: state => {
  //   return state.constructions;
  // },

}

const mutations = {
  search(state, {
    type,
    value
  }) {
    state.search[type] = value;
  },
  // items(state, payload) {
  //   state.constructions = payload;
  // },

};

export default {
  namespaced: true,
  state,
  getters,
  mutations
};